const costSheetTemplate = ({
    name,
    property_type,
    property_no,
    building_no,
    floor,
    property_type_desc,
    carpet_area,
    balcony_area,
    dry_balcony_area,
    total_area,
    base_price,
    floor_rise,
    stamp_duty,
    stampDutyParking,
    registration_price,
    gst,
    legalCharges,
    grossGovernmentCharges,
    totalB,
    totalC,
    grandTotal,
    costSheetTerms,
    mseb,
    infraCharges,
    societyFormationCharges
  }) => {
    return (
      `<!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Cost Sheet</title>
          <style>
              body {
                  justify-content: center;
                  align-items: center;
                  font-family: Arial, sans-serif;
                  color: #333;
                  line-height: 1.6;
                  margin: 0;
                  padding: 20px;
                  background-color: transparent;
              }
              .container {
                  width: 100%;
                  max-width: 700px;
                  padding: 15px;
                  margin: auto;
                  box-sizing: border-box;
              }
              table {
                  width: 100%;
                  border-collapse: collapse;
              }
              th, td {
                  padding: 8px;
                  text-align: left;
                  border-right: 1px solid #ddd;
              }
              th {
                  font-weight: bold;
                  color: #000000;
              }
              tr {
                  border-bottom: 1px solid #ddd;
                  border-left: 1px solid #ddd;
              }
              tr:last-child {
                  border-bottom: none;
              }
              .header {
                  text-align: center;
                  border-right: 1px solid #ddd;
                  border-left: 1px solid #ddd;
                  border-top: 1px solid #ddd;
                  padding-bottom: 10px;
              }
              .header h2 {
                  font-size: 18px;
                  margin: 0;
              }
              .terms-conditions {
                  min-height: 80px;
                  margin: 20px;
                  padding: 5px;
                  font-size: 11px;
              }
              .authorised-signatory {
                  text-align: right;
                  padding-top: 80px;
                  margin-top: 80px;
              }
              .authorised-signatory div {
                  width: 200px;
                  border-bottom: 1px dashed #000;
                  margin-left: auto;
              }
              .authorised-signatory p {
                  margin: 5px 0;
                  font-size: 14px;
                  font-style: italic;
                  color: #777;
                  text-align: right;
              }
          </style>
      </head>
      <body>
          <div class="container">
              <table>
                  <thead>
                      <tr style="border-bottom: 2px solid #95a5a6;">
                          <th colspan="3" class="header">
                              <h2>COST SHEET</h2>
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td colspan="3">
                              <p>
                                  <strong>Name:</strong>
                                  <span>${name}</span>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td colspan="3">
                              <p>
                                  <strong>Address:</strong>
                                  <span>${property_type} no ${property_no} - BUILDING ${building_no} - FLOOR No ${floor}</span>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <th></th>
                          <th>PARTICULAR</th>
                          <th>${property_type_desc}</th>
                      </tr>
                      <tr>
                          <th>UNIT DETAILS</th>
                          <th></th>
                          <th>SQ.FT</th>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Carpet Area</td>
                          <td>${carpet_area}</td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Balcony Area</td>
                          <td>${balcony_area}</td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Dry Balcony Area</td>
                          <td>${dry_balcony_area}</td>
                      </tr>
                      <tr>
                          <th>AGREEMENT VALUE (A)</th>
                          <td>AGREEMENT VALUE</td>
                          <td>${base_price}</td>
                      </tr>
                      <tr>
                           <td></td>
                          <td>Floor rise Charges</td>
                          <td>${floor_rise}</td>
                      </tr>
                      <tr>
                          <th>OTHER CHARGES (B)</th>
                          <td colspan="2"></td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>MSEB</td>
                          <td>${mseb}</td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Infra Charges</td>
                          <td>${infraCharges}</td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Society Formation Charges</td>
                          <td>${societyFormationCharges}</td>
                      </tr>
                   
                      <tr>
                          <td></td>
                          <td>Total (B)</td>
                          <td>${totalB}</td>
                      </tr>
                      <tr>
                          <th>GOVERNMENT CHARGES (C)</th>
                          <td colspan="2"></td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Stamp Duty</td>
                          <td>${stamp_duty}</td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Stamp Duty on parking</td>
                          <td>${stampDutyParking}</td>
                      </tr>
                   
                      <tr>
                          <td></td>
                          <td>Registration Charges</td>
                          <td>${registration_price}</td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>GST</td>
                          <td>${gst}</td>
                      </tr>
                      <tr>
                           <td></td>
                          <td>Legal Charges</td>
                          <td>${legalCharges}</td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Gross Government Charges</td>
                          <td>${grossGovernmentCharges}</td>
                      </tr>
                      <tr>
                          <td></td>
                          <td>Total (C)</td>
                          <td>${totalC}</td>
                      </tr>
                   
                      <tr style="padding-bottom: 280px;">
                          <th>GRAND TOTAL</th>
                          <th>A+B+C</th>
                          <td>${grandTotal}</td>
                      </tr>
                     
                      <tr>
                          <th colspan="3" style="text-align: center; padding-top: 22px;">TERMS & CONDITIONS</th>
                      </tr>
                     
                  </tbody>
              </table>
          </div>
      </body>
      </html>`
    )
  }
  export default costSheetTemplate;